export enum AccountIalEnum {
  LOW = 'LOW', MEDIUM = 'MEDIUM', HIGH = 'HIGH'
}

export enum AccountInvitationStatus {
  AWAITING = 'AWAITING', ACCEPTED = 'ACCEPTED', REJECTED = 'REJECTED', EXPIRED = 'EXPIRED', CANCELED = 'CANCELED'
}

export const enum AccountStatusEnum {
  ACTIVE = 'ACTIVE', INACTIVE = 'INACTIVE', BLOCKED = 'BLOCKED', DISABLED = 'DISABLED', ANONYMIZE = 'ANONYMIZE'
}

export interface AccountDetailsModel {
  email?: string;
  expectedIal?: AccountIalEnum;
  externalId?: string;
  firstName?: string;
  ial?: AccountIalEnum;
  lastName?: string;
  disabledPlannedDate?: Date;
  lockDate?: Date;
  lockReason?: string;
  phone?: string;
  registrationDate?: Date;
  sharePhone?: boolean;
  status?: AccountStatusEnum;
}

export interface ConfirmationDocument {
  document: string;
  factors: string[];
}

export interface AccountUpdateModel {
  code?: string;
  currentEmail?: string;
  externalId?: string;
  documents?: ConfirmationDocument[];
  email?: string;
  expectedIal?: keyof typeof AccountIalEnum;
  ial?: keyof typeof AccountIalEnum;
  firstName?: string;
  lastName?: string;
  lowSecurityReason?: string;
  operator?: string;
  phone?: {
    number: string;
    prefix: string;
  };
  section?: number;
  sharePhone?: boolean;
  smsCode?: string;
}
